module.exports = __webpack_public_path__ + "img/6-kattenbakken.951f7f98.jpg";